import { HeaderName } from '../HeaderName';
const SAS_REQUEST = HeaderName.SASRequest;
let totalRequestCount = 0;
const requestCountMap = {};
export const addSASRequestHeader = config => {
  if (!config.traceId) {
    return config;
  }
  if (!requestCountMap[config.traceId]) {
    requestCountMap[config.traceId] = 0;
  }
  if (!config.headers) {
    config.headers = {};
  }
  if (!config.headers[SAS_REQUEST]) {
    config.headers[SAS_REQUEST] = `${config.traceId};${requestCountMap[config.traceId]};${totalRequestCount}`;
  }
  totalRequestCount++;
  requestCountMap[config.traceId]++;
  return config;
};
//# sourceMappingURL=sas-request.js.map